import type { StateCreator } from 'zustand';
import type { GuidedDoctorConsultsActions, GuidedDoctorConsultsSliceType } from '../types';

export const toggleSection: StateCreator<
  GuidedDoctorConsultsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  GuidedDoctorConsultsActions['toggleSection']
> = (set) => {
  return (sectionName) => {
    set(
      (state) => {
        const openSections = state.guidedDoctorConsult.openSections;
        const sectionIndex = openSections.indexOf(sectionName);

        if (sectionIndex === -1) {
          openSections.push(sectionName);
        } else {
          openSections.splice(sectionIndex, 1);
        }
      },
      false,
      'guidedDoctorConsult/toggleSection',
    );
  };
};
